import { render, staticRenderFns } from "./card-grammar.vue?vue&type=template&id=29a4dfae&"
import script from "./card-grammar.vue?vue&type=script&lang=js&"
export * from "./card-grammar.vue?vue&type=script&lang=js&"
import style0 from "./card-grammar.vue?vue&type=style&index=0&id=29a4dfae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports